<template>
  <div class="mv-bg-main">
    <el-card >
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" ref="searchForm" :model="form" class="demo-form-inline ">
        <el-form-item label="业务系统" prop="sysId">
          <el-select
            v-model="form.sysId"
            placeholder="请选择业务系统"
            clearable
            filterable
          >
            <el-option
              v-for="(item, index) in sysData"
              :key="index"
              :label="item.systemName"
              :value="item.systemId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通道名称" prop="pathName">
          <el-input style="width: 217px;" clearable v-model="form.pathName" placeholder="请输入通道名称"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="创建日期" prop="date">
          <el-date-picker
            v-model="form.date"
            :editable = "editable"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="通道状态" prop="pathState">
          <el-select  v-model="form.pathState" clearable filterable  placeholder="请选择通道状态">
            <el-option label="正常" value="1" ></el-option>
            <el-option label="停用" value="0" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="float-r">
          <el-button size="small" @click="onReset('searchForm')">重置</el-button>
          <el-button size="small" type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-top">
      <div slot="header" class="clearfix">
        <span class="card-title">查询结果</span>
        <el-button type="primary" size="small" style="float: right; margin-top: -10px;" icon="el-icon-delete" @click="moreDelete"></el-button>
        <el-button type="primary" size="small" style="float: right; margin-top: -10px; margin-right: 10px;" @click="handleAdd" icon="el-icon-plus"></el-button>
      </div>
      <el-table
        :data="tableData"
        @selection-change="changeFun"
        style="width: 100%">
        <el-table-column
          type="selection"
          fixed="left"
          @selection-change="changeFun">
        </el-table-column>
        <el-table-column
          label="业务系统"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.sysName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="通道名称"
          :show-overflow-tooltip="tooltip"
          width="500">
          <template slot-scope="scope">
            <span class="link" @click="detail(scope.$index, scope.row)">{{ scope.row.pipeName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="通道状态"
          :show-overflow-tooltip="tooltip"
          width="120px">
          <template slot-scope="scope">
            <span >{{ scope.row.pipeState === 1 ? '启用': '停用' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="关联供应商"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.supShortName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="关联供应商服务"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.serviceName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          :show-overflow-tooltip="tooltip"
          width="180px">
          <template slot-scope="scope">
            <span >{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="通道描述"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.remark }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" @click="reletedProduct(scope.$index, scope.row)">已关联产品</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
    <el-dialog @close="closePath" :title="pathTitle" :modal-append-to-body='false' width="550px" center  :visible.sync="pathDialog">
      <el-form :model="pathInfo" :rules="pathRule" ref="pathInfo" >
        <el-form-item label="业务系统" :required="required" :label-width="formLabelWidth" prop="sysId">
          <el-select
            @change="selectSys"
            v-model="pathInfo.sysId"
            placeholder="请选择业务系统"
            clearable
            filterable
          >
            <el-option
              v-for="(item, index) in sysData"
              :key="index"
              :label="item.systemName"
              :value="item.systemId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通道名称:" prop="pathName"  :required="required" :label-width="formLabelWidth">
          <el-input style="width: 217px;" placeholder="请输入通道名称" maxlength="80" clearable v-model="pathInfo.pathName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="通道状态:" prop="pathState" :required="required"  :label-width="formLabelWidth">
          <el-select  v-model="pathInfo.pathState" clearable filterable  placeholder="请选择通道状态">
            <el-option label="启用" value="1" ></el-option>
            <el-option label="停用" value="0" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通道路径:" prop="pipePath" :required="required" :label-width="formLabelWidth">
          <el-input style="width: 217px;" placeholder="请输入通道路径" maxlength="80" clearable v-model="pathInfo.pipePath" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述:" :label-width="formLabelWidth">
          <el-input type="textarea" style="width: 217px;" maxlength="150" placeholder="请输入描述" v-model="pathInfo.desc"></el-input>
        </el-form-item>
        <el-form-item label="供应商:" prop="supId" :required="required" :label-width="formLabelWidth" >
          <el-select  v-model="pathInfo.supId" @change="supChange" clearable filterable  placeholder="请选择供应商">
            <el-option :label="item.supName" :value="item.supId" v-for="(item, $index) in supData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务名称:" prop="supServiceId" :required="required" :label-width="formLabelWidth"  >
          <el-select  v-model="pathInfo.supServiceId" clearable filterable  placeholder="请选择服务名称">
            <el-option :label="item.supServiceName" :value="item.supServiceId" v-for="(item, $index) in serviceData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="连接超时时间:" prop="conTimeout" :required="required" :label-width="formLabelWidth" >
          <el-input style="width: 217px;" maxlength="9" clearable v-model="pathInfo.conTimeout" auto-complete="off"></el-input>
          <span>(ms)</span>
        </el-form-item>
        <el-form-item label="socket超时:" prop="soTimeout" :required="required" :label-width="formLabelWidth" >
          <el-input style="width: 217px;" maxlength="9" clearable v-model="pathInfo.soTimeout" auto-complete="off"></el-input>
          <span>(ms)</span>
        </el-form-item>
        <el-form-item style="textAlign: center;">
          <el-button @click="pathDialog=false">取 消</el-button>
          <el-button type="primary" v-show="add" @click="addSave('pathInfo')">确 定</el-button>
          <el-button type="primary" v-show="!add" @click="editSave('pathInfo')">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="已关联产品"  width="860px" center :modal-append-to-body='false' :visible.sync="productDialog">
      <el-table
        :data="productData"
        style="width: 100%">
        <el-table-column
          label="产品名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.abilityName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="英文名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.abilityEnName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="通道组"
          :show-overflow-tooltip="tooltip"
          width="120px">
          <template slot-scope="scope">
            <span >{{ scope.row.groupNames.join(',') }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :title="detailTitle"  width="860px" center :modal-append-to-body='false' :visible.sync="detailDialog">
      <el-table
        :data="detailData"
        style="width: 100%">
        <el-table-column
          label="供应商"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.supName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="供应商服务"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.supServiceName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="连接超时时间(ms)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.connectTimeout }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="socket超时时间(ms)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.socketTimeout }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
</style>
<script>
export default {
  name: 'pathManage',
  data () {
    return {
      form: {
        pathName: '',
        pathState: '',
        sysId: '',
        date: ''
      },
      detailDialog: false,
      detailTitle: '',
      detailData: [],
      tooltip: true,
      productDialog: false,
      productData: [], // 已关联产品
      required: true,
      pathDialog: false,
      editable: false,
      modalClick: false,
      formLabelWidth: '160px',
      add: false,
      pathTitle: '',
      tableData: [],
      supData: [], // 供应商
      serviceData: [], // 供应商服务
      delete: [], // 删除
      pipeId: '',
      abilityPipeServiceRefId: '',
      pathInfo: {
        pathName: '',
        pathState: '',
        pipePath: '',
        sysId: '',
        desc: '',
        supId: '',
        supServiceId: '',
        conTimeout: '',
        soTimeout: ''
      },
      pathRule: {
        pathName: [
          { required: true, message: '请输入通道名称', trigger: ['blur', 'change'] },
          { min: 1, max: 80, message: '长度在1至30个字符', trigger: ['blur', 'change'] }
        ],
        pipePath: [
          { required: true, message: '请输入通道路径', trigger: ['blur', 'change'] },
          { min: 1, max: 80, message: '长度在1至30个字符', trigger: ['blur', 'change'] }
        ],
        pathState: [
          { required: true, message: '请选择通道状态', trigger: 'change' }
        ],
        supId: [
          { required: true, message: '请选择供应商名称', trigger: 'change' }
        ],
        sysId: [
          { required: true, message: '请选择业务系统', trigger: 'change' }
        ],
        supServiceId: [
          { required: true, message: '请选择供应商服务', trigger: 'change' }
        ],
        conTimeout: [
          { required: true, message: '请输入连接超时时间', trigger: ['blur', 'change'] },
          { validator: this.regular.greaterThanZero, trigger: ['blur', 'change'] }
        ],
        soTimeout: [
          { required: true, message: '请输入socket超时时间', trigger: ['blur', 'change'] },
          { validator: this.regular.greaterThanZero, trigger: ['blur', 'change'] }
        ]
      },
      currentPage: 1,
      page: 10,
      total: 0
    }
  },
  activated () {
    // this.query()
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    onSubmit () {
      this.currentPage = 1
      this.query()
    },
    changeFun (val) { // checkbox 选中时获取服务id
      this.delete = []
      if (val.length) {
        for (let v of val) {
          this.delete.push(v.pipeId)
        }
      }
    },
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    reletedProduct (index, row) { // 已关联产品
      let op = {}
      op.pipeId = row.pipeId
      this.$axios({
        url: this.$API.product.queryUsedAbilityGroup,
        method: 'post',
        data: op
      }).then((response) => {
        if (!response.data.resData) return
        this.productData = response.data.resData.data
        this.productDialog = true
      })
    },
    detail (index, row) { // 详情
      let op = {}
      op.pipeId = row.pipeId
      let _this = this
      this.$axios({
        url: this.$API.product.getAbilityPipeById,
        method: 'get',
        params: op
      }).then((response) => {
        if (!response.data.resData) return
        _this.detailData = response.data.resData.abilityPipeServiceRefList
        if (response.data.resData.pipeName) {
          _this.detailTitle = response.data.resData.pipeName
        }
        if (response.data.resData.serviceList.length) {
          _this.detailData.forEach((i, v) => {
            response.data.resData.serviceList.forEach((g, k) => {
              console.log(g)
              if (i.supServiceId === g.supServiceId) {
                i.supName = g.supName
                i.supServiceName = g.supServiceName
              }
            })
          })
        }
        _this.detailDialog = true
      })
    },
    supChange (val) {
      console.log(val)
      if (val) {
        this.pathInfo.supServiceId = ''
        this.$axios({ // 查询供应商服务
          url: this.$API.product.querySupServiceBySupId,
          method: 'get',
          params: {param: { 'supId': val, 'supServiceIdList': [] }}
        }).then((response) => {
          this.serviceData = response.data.resData // 供应商服务
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    handleEdit (index, row) { // 编辑
      this.pipeId = row.pipeId
      let _this = this
      if (row.sysId) {
        this.selectSys(row.sysId)
      }
      this.$axios({ // 查询编辑通道详情
        url: _this.$API.product.getAbilityPipeById,
        method: 'get',
        params: { pipeId: row.pipeId }
      }).then((response) => {
        if (!response.data.resData) return
        let supServiceIdList = []
        let data = response.data.resData
        this.abilityPipeServiceRefId = data.abilityPipeServiceRefList[0].abilityPipeServiceRefId
        this.pathInfo.sysId = Number(data.sysId)
        this.pathTitle = '编辑通道'
        data.abilityPipeServiceRefList.forEach((v, i) => {
          if (data.serviceList && data.serviceList[i] && (data.serviceList[i].supServiceId === v.supServiceId)) {
            supServiceIdList.push(v.supServiceId) // data.serviceList 存在查询供应商服务
            this.pathInfo.supId = data.serviceList[0].supId // 供应商id
            this.pathInfo.conTimeout = data.abilityPipeServiceRefList[0].connectTimeout
            this.pathInfo.soTimeout = data.abilityPipeServiceRefList[0].socketTimeout
            _this.$axios({ // 查询供应商服务
              url: _this.$API.product.querySupServiceBySupId,
              method: 'get',
              params: {param: { 'supId': data.serviceList[0].supId, 'supServiceIdList': supServiceIdList }}
            }).then((response) => {
              _this.serviceData = response.data.resData // 供应商服务
              _this.pathInfo.supServiceId = data.serviceList[0].supServiceId // 供应商服务id
              _this.pathDialog = true
            }).catch((err) => {
              console.log(err)
            })
          } else {
            _this.pathDialog = true
          }
        })
      }).catch((err) => {
        console.log(err)
      })
      this.pathInfo.pathName = row.pipeName
      this.pathInfo.pathState = row.pipeState + ''
      this.pathInfo.pipePath = row.pipePath
      this.pathInfo.desc = row.remark
      this.add = false
    },
    closePath () {
      this.pathInfo = {
        pathName: '',
        pathState: '',
        pipePath: '',
        desc: '',
        sysId: '',
        supId: '',
        supServiceId: '',
        conTimeout: '',
        soTimeout: ''
      }
      this.serviceData = []
      this.$refs['pathInfo'].resetFields() // 关闭时清除验证条件
      this.pathDialog = false
    },
    moreDelete () {
      if (this.delete.length === 0) {
        this.$message.error('请选择通道')
        return
      }
      let _this = this
      this.$confirm('此操作将永久删除通道, 是否继续?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$axios({
          url: this.$API.product.deleteAbilityPipe,
          method: 'post',
          data: {'pipeIdList': _this.delete}
        }).then((response) => {
          _this.query()
          _this.$message.success('通道删除成功')
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    selectSys (val) {
      let id = val
      let _this = this
      this.pathInfo.supId = ''
      this.$axios({ // 查询供应商
        method: 'post',
        url: _this.$API.supplier.querySupInfoAllBySysId,
        data: { sysId: id }
      }).then((response) => {
        if (response && response.data) {
          _this.supData = response.data.resData
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
    },
    editSave (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          let sysIds = []
          sysIds.push(_this.pathInfo.sysId)
          op.pipeName = _this.pathInfo.pathName
          op.pipeState = _this.pathInfo.pathState
          op.pipePath = _this.pathInfo.pipePath
          op.remark = _this.pathInfo.desc
          op.sysIds = sysIds
          op.abilityPipeServiceRefList = []
          op.pipeId = _this.pipeId
          let dataOp = {}
          dataOp.supId = _this.pathInfo.supId
          dataOp.supServiceId = _this.pathInfo.supServiceId
          dataOp.connectTimeout = _this.pathInfo.conTimeout
          dataOp.socketTimeout = _this.pathInfo.soTimeout
          dataOp.abilityPipeServiceRefId = _this.abilityPipeServiceRefId
          op.abilityPipeServiceRefList.push(dataOp)
          _this.$axios({
            url: _this.$API.product.updateAbilityPipe,
            method: 'post',
            data: op
          }).then((response) => {
            _this.query()
            _this.$message.success('通道编辑成功!')
            _this.pathDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    handleAdd () {
      this.add = true
      this.pathTitle = '新增通道'
      this.pathDialog = true
    },
    addSave (formName) { // 新增客户类型
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          let sysIds = []
          sysIds.push(_this.pathInfo.sysId)
          op.pipeName = _this.pathInfo.pathName
          op.pipeState = _this.pathInfo.pathState
          op.pipePath = _this.pathInfo.pipePath
          op.remark = _this.pathInfo.desc
          op.sysIds = sysIds
          op.abilityPipeServiceRefList = []
          let dataOp = {}
          dataOp.supId = _this.pathInfo.supId
          dataOp.supServiceId = _this.pathInfo.supServiceId
          dataOp.connectTimeout = _this.pathInfo.conTimeout
          dataOp.socketTimeout = _this.pathInfo.soTimeout
          op.abilityPipeServiceRefList.push(dataOp)
          _this.$axios({
            url: _this.$API.product.addAbilityPipe,
            method: 'post',
            data: op
          }).then((response) => {
            _this.query()
            _this.$message.success('通道新增成功!')
            _this.pathDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    initData () {
      this.$store.dispatch('getSystem') // 请求业务系统
      // let _this = this
      // this.$axios({ // 查询供应商
      //   url: _this.$API.rechargeManagement.querySupInfoAll,
      //   method: 'get'
      // }).then((response) => {
      //   if (!response.data.resData) return
      //   _this.supData = response.data.resData
      // }).catch((err) => {
      //   console.log(err)
      // })
      this.query()
    },
    query () {
      let op = {}
      let id = this.form.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      let _this = this
      op.pageNumber = this.currentPage
      op.pageSize = this.page
      op.pipeName = this.form.pathName
      op.pipeState = this.form.pathState
      op.sysIds = sysIds
      op.createTimeSearchStart = this.form.date ? this.form.date[0] : null
      op.createTimeSearchEnd = this.form.date ? this.form.date[1] : null
      this.$axios({
        url: _this.$API.product.queryAbilityPipeByPage,
        method: 'post',
        data: op
      }).then((response) => {
        console.log(response)
        _this.tableData = response.data.resData.resultList
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.initData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/proManage/pathManage.vue